import { useTranslation } from 'react-i18next';
import { Modal, Button } from '@teo/components';

function SessionExpiredModal({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  if (!open) return null;

  return (
    <Modal isOpen>
      <Modal.Header onClose={onClose}>
        {t('forms.session_expired.title')}
      </Modal.Header>
      <Modal.Body>{t('forms.session_expired.description')}</Modal.Body>
      <Modal.Footer>
        <div className="flex w-full justify-end">
          <Button onClick={onClose}>{t('forms.confirm')}</Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export { SessionExpiredModal };
